<template>
  <div class = "page">
    <img class="bg_img" src="../assets/img/logon.png" />
    <div class="sys_name">顾村公园智慧屏平台</div>

    <div class="info_name">
      <div class="info_detail">
        <div>账号</div>
        <input id = "userName" v-model="userName" type="text" />
      </div>
    </div>

    <div class="info_password">
      <div class="info_detail">
        <div>密码</div>
        <input id = "passWord" v-model="passWord" type="password" />
      </div>
    </div>
    <div class="remember">
      <img class="icon_r" :src="rememberMeFlag ? require('../assets/img/jx_choose.png'): require('../assets/img/jx.png')" @click="rememberMe"/>
      <div class="remember_me" @click="rememberMe">记住我</div>
    </div>
    <img class="logon_button" src="../assets/img/logon_button.png" v-on:click="login" />
  </div>
</template>

<script>
  import {submitForm} from '../api/login.js';

  export default {
    name: "app_login",
    data() {
      return {
        imgSrc: require('../assets/img/bg_1png.png'),
        rememberMeFlag:false,
        userName : "",
        passWord : "",
        userToken : ""
      }
    },
    created() {
    },
    methods:{
      rememberMe(){
        this.rememberMeFlag = ! this.rememberMeFlag;
      },
      login(){
        let _this = this;
        var name = this.userName
        var pass = this.passWord
        var data = {}
        if(name.trim() == ""){
          alert("请输入用户名")
          return;
        }else {
          data.userName = name
        }
        if(pass.trim() == ""){
          alert("请输入密码")
          return;
        }else {
          data.passWord = pass
        }
        if(name.trim() != "" && pass.trim() != ""){
          submitForm(data).then((res) =>{
            res.message
            console.info("res : " + JSON.stringify(res))
            if(res.code == 200){
              //判断是否记住密码
              if(this.rememberMeFlag){
                //点击了选中按钮
                localStorage.setItem("rememberMeFlag",0);
              }
              localStorage.setItem("Authorization",res.data.token);
              // this.setLocalStorage('Authorization', res.data.token);
              this.$router.push({
                path: '/app_dp'
              })
            }else {
              alert(res.message)
            }
          })
        }
      },
      setLocalStorage(key,value){
        var curTime = new Date().getTime();
        localStorage.setItem(key,JSON.stringify({data:value,time:curTime}));
      },
      getLocalStorage(key,exp){
        var data = localStorage.getItem(key);
        if(data){
          var dataObj = JSON.parse(data);
          if (new Date().getTime() - dataObj.time>exp) {
            console.log('已过期');
            localStorage.removeItem(key);
          }else{
            console.log('未过期');
            return JSON.parse(dataObj.data)
          }
        }
        return null;
      }
    }
  }
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
  .page {
    font-size: 0;
    width: 100%;
    height: 100%;
    background-color: #081e3d;
  }

  .bg_img{
    width: 100%;
    height: 1.2rem;
    margin-top: .6rem;
  }

  .sys_name{
    margin-top: 1.45rem;
    margin-left: .6rem;
    height: .5rem;
    line-height: .5rem;
    font-size: .46rem;
    font-family: "PingFang";
    color: rgb(255, 255, 255);
    font-weight: bold;
    width: calc(100% - 1.2rem);
  }

  .info_name{
    height: 1.1rem;
    width: calc(100% - 1.2rem);
    margin-left: .6rem;
    margin-top: .57rem;
    background-color: #0e284a;
    line-height: 1.1rem;
  }

  .info_password{
    height: 1.1rem;
    width: calc(100% - 1.2rem);
    margin-left: .6rem;
    margin-top: .22rem;
    background-color: #0e284a;
    line-height: 1.1rem;
  }

  .info_detail{
    width: calc(100% - 0.8rem);
    margin-left: .4rem;

  }

  .info_detail > div{
    font-size: .3rem;
    font-family: "PingFang";
    color: rgb(255, 255, 255, 0.302);
    vertical-align: middle;
    display: inline-block;
  }

  .info_detail >input{
    margin-left: .2rem;
    vertical-align: middle;
    display: inline-block;
    width: calc(100% - 1rem);
    font-size: .3rem;
    font-family: "PingFang";
    color: rgb(255, 255, 255);
    outline-color: invert ;
    outline-style: none ;
    outline-width: 0px ;
    border: none ;
    border-style: none ;
    text-shadow: none ;
    -webkit-appearance: none ;
    -webkit-user-select: text ;
    outline-color: transparent ;
    box-shadow: none;
    background-color: #0e284a;
  }

  .remember {
    margin-left: .6rem;
    margin-top: 0.5rem;
  }
  .icon_r {
    width: 0.3rem;
    height: 0.3rem;
    display: inline-block;
    vertical-align: top;
  }
  .remember_me {
    font-size: 0.26rem;
    font-family: "SourceHanSansCN";
    color: #fff;
    line-height: 0.3rem;
    display: inline-block;
    margin-left: .1rem;
  }

  .logon_button{
    margin-top: .6rem;
    margin-left: .6rem;
    width: calc(100% - 1.2rem);
    height: 1.1rem;
  }

</style>



// WEBPACK FOOTER //
// src/components/app_login.vue